module.exports = __webpack_public_path__ + "media/images/85/gym-b29bdb903fe723f299050074e731c876.webp";